import CloseIcon from "@mui/icons-material/Close";
import { Stack } from "@mui/material";
import Button from "@mui/material/Button";
import { NotificationResource } from "models/Resources/NotificationResource";
import { SnackbarKey, useSnackbar, VariantType } from "notistack";
import { useEffect } from "react";
import { MARK_AS_READ_BUTTON_MESSAGE } from "../Notifications/NotificationDetails/NotificationDetails";

type Props = {
  newImportantNotification?: NotificationResource;
  handleNotificationReadClick: (id: string) => void;
};

const NotificationSnackBar = ({
  newImportantNotification,
  handleNotificationReadClick,
}: Props) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  function handleSnackbarReadClick(notificationId: string) {
    if (!newImportantNotification?.archivedBy)
      handleNotificationReadClick(notificationId);
  }

  const markAsRead = (notificationId: string, snackbarId: SnackbarKey) => (
    <Stack
      style={{
        width: "max-content",
        flexDirection: "row",
      }}>
      <Button
        color="inherit"
        size="small"
        onClick={() => {
          handleSnackbarReadClick(notificationId);
          closeSnackbar(snackbarId);
        }}>
        {MARK_AS_READ_BUTTON_MESSAGE}
      </Button>
      <Button onClick={() => closeSnackbar(snackbarId)}>
        <CloseIcon style={{ color: "white" }} />
      </Button>
    </Stack>
  );

  useEffect(() => {
    if (newImportantNotification) {
      enqueueSnackbar(newImportantNotification.title.replace("^c",""), {
        action: snackbarId =>
          markAsRead(newImportantNotification.notificationId, snackbarId),
        variant: ["success", "error", "warning", "info"].includes(
          (newImportantNotification?.severity ?? "").toLowerCase()
        )
          ? (newImportantNotification!.severity!.toLowerCase() as VariantType)
          : "default",
      });
    }
  }, [newImportantNotification, enqueueSnackbar]);

  return null;
};

export default NotificationSnackBar;
